interface TextareaFieldProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

const TextAreaField: React.FC<TextareaFieldProps> = ({
  label,
  maxLength = 500,
  rows = 4,
  error,
  ...rest
}) => {
  return (
    <div>
      <label htmlFor={rest.name} className="block text-black mb-1">
        {label}
      </label>
      <textarea
        {...rest}
        id={rest.name}
        className={`w-full p-2 border rounded-md text-gray-700 ${
          error ? "border-red-500" : "border-gray-600"
        }`}
        maxLength={maxLength}
        rows={rows}
      />
      <div className="flex justify-between items-center text-sm mt-1">
        <span className="text-red-500">{error}</span>
        <span className="text-gray-500">Maximum {maxLength} characters</span>
      </div>
    </div>
  );
};

export default TextAreaField;
